export var config = {
  background: '#390000',
  foreground: '#F8F8F8',
  selection: '#750000',
  selectionMatch: '#750000',
  cursor: '#970000',
  dropdownBackground: '#580000',
  activeLine: '#ff000033',
  matchingBracket: '#ff000033',
  keyword: '#f12727ff',
  storage: '#ff6262ff',
  variable: '#edef7dff',
  parameter: '#edef7dff',
  function: '#ffb454ff',
  string: '#edef7dff',
  constant: '#ec0d1e',
  type: '#9df39fff',
  class: '#fec758ff',
  number: '#994646ff',
  comment: '#e7c0c0ff',
  heading: '#fec758ff',
  invalid: '#ffffffff',
  regexp: '#edef7dff',
  tag: '#aa5507ff'
};